module.exports = __webpack_public_path__ + "img/produit_bio.00666f1c.png";